import React, { Component } from 'react';  //eslint-disable-line no-irregular-whitespace
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import NotifyMsg from './NotifyMsg';
import { dismissAlert } from './msgNotifyActions';

class MsgNotifier extends Component {
  render() {
    const { dispatch } = this.props;
    var msgNodes = this.props.messages.map(function(msg, index){
      return (
        <NotifyMsg
          key={msg.id}
          index={index}
          alert={msg}
          dismissAlert={alertIndex => dispatch(dismissAlert(alertIndex))}
        />
      );
    });
    return (
      <div style={styles.msg_notifier}>
          {msgNodes}
      </div>
    );
  }
}

function selectProps(state) {
  return {
    messages: state.alertMsgReducer.messages
  };
}

var styles = {
  msg_notifier :{
    position: 'fixed',
    right: '30px',
    top: '75px',
    width: '25%',
    zIndex: '9999'
  }
};
  MsgNotifier.propTypes = {
    messages: PropTypes.arrayOf(PropTypes.shape({
      alertType: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      msg: PropTypes.string.isRequired
    }))
  };

  var w = Radium(MsgNotifier)
export default connect(selectProps)(w);


// WEBPACK FOOTER //
// ./src/App/MsgNotify/msgNotifier.jsx